import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/event.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import { Modal } from "react-bootstrap";
import BackButton from "../ChildComponent/BackButton";

const DOCUMENT_TYPE = "event_invitation";

const EventInvitation = () => {
  const { event_id } = useParams();

  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [showInvitationPreview, setShowInvitationPreview] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mInvitationSamples, setMInvitationSamples] = useState([]);
  const [mColorOption, setMColorOption] = useState([]);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [EVENT_ID, setEVENT_ID] = useState(event_id);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [SELECTED_COLOR_POSITION, setSELECTED_COLOR_POSITION] = useState(0);
  const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState("");
  const [eventDetails, setEventDetails] = useState(null);
  const [isOpenEventDialog, setIsOpenEventDialog] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [height, setHeight] = useState("800px");
 

  // Memoize school code
  const SCHOOL_CODE = useMemo(() => SessionManager.getSchoolCode(), []);

  // Memoize current session
  const currentSession = useMemo(() => SessionManager.getCurrentSession(), []);

  useEffect(() => {
    if (event_id) {
      getEventDetails();
    }
    getInvitationSamples();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event_id]);

  // Handle iframe height adjustment
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const getEventList = useCallback(() => {
    setLoadingEvents(true);
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventList.php?`;

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE } })
      .then((res) => res.data)
      .then((response) => {
        setLoadingEvents(false);
        if (response.api_status === "OK") {
          setEventList(response.data || []);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch(() => {
        setLoadingEvents(false);
        myToast.notify_error("Error loading event list");
      });
  }, [SCHOOL_CODE]);

  const handleOpenEventDialog = useCallback(() => {
    setIsOpenEventDialog(true);
    getEventList();
  }, [getEventList]);

  const handleCloseEventDialog = useCallback(() => {
    setIsOpenEventDialog(false);
  }, []);

  const handleSelectEvent = useCallback((event) => {
    setEventDetails(event);
    setEVENT_ID(event.event_id);
    setIsOpenEventDialog(false);
    window.history.pushState({}, '', `/AdminMain/EventInvitation/${event.event_id}`);
    
  }, []);

  const getEventDetails = useCallback(() => {
    if (!event_id) return;
    
    setLoading(true);
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventDetails.php`;

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE, event_id } })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const eventData = Array.isArray(response.data) ? response.data[0] : response.data;
          if (eventData) {
            setEventDetails(eventData);
          } else {
            myToast.notify_warning("No event details found");
          }
        } else {
          myToast.notify_warning(response.api_remark || "Failed to load event details");
        }
      })
      .catch(() => {
        setLoading(false);
        myToast.notify_error("Error loading event details");
      });
  }, [event_id, SCHOOL_CODE]);

  const getInvitationSamples = useCallback(() => {
    setLoading(true);
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getPrintableSample.php`;

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE, document_type: DOCUMENT_TYPE } })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && response.data?.length > 0) {
          setMInvitationSamples(response.data);
          // Set initial sample after state update
          setTimeout(() => {
            setSample(SELECTED_SAMPLE_POSITION, response.data);
          }, 0);
        } else {
          myToast.notify_warning(response.api_remark || "No invitation templates found");
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, [SCHOOL_CODE, SELECTED_SAMPLE_POSITION]);

  const setFileUrLWithFileInfo = useCallback((fileDirectory, fileName, sampleId, students = mSelectedStudent) => {
    const mStudentIds = students.length > 0 ? students.map((s) => s.student_enrollment_no) : [];
    const firstStudent = students[0] || {};
    const session_id = firstStudent.session_id || (currentSession?.session_id || "");
    const class_id = firstStudent.class_id || "null";
    const section_id = firstStudent.section_id || "null";

    const url = `${process.env.REACT_APP_SERVER_NAME}${fileDirectory}${fileName}?student_ids=${encodeURIComponent(
      JSON.stringify(mStudentIds)
    )}&class_id=${encodeURIComponent(class_id)}&section_id=${encodeURIComponent(
      section_id
    )}&session_id=${session_id}&sample_id=${sampleId}&selection_type=student&system_code=${
      process.env.REACT_APP_SYSTEM_CODE
    }&color_option_id=${COLOR_OPTION_ID}&event_id=${EVENT_ID}&school_code=${SCHOOL_CODE}`;

    console.log("Event Invitation URL:", url);
    setFILE_URL(url);
  }, [mSelectedStudent, currentSession, COLOR_OPTION_ID, EVENT_ID, SCHOOL_CODE]);

  const setFileUrL = useCallback((students = mSelectedStudent) => {
    setFileUrLWithFileInfo(FILE_DIRECTORY, FILE_NAME, SELECTED_SAMPLE_ID, students);
  }, [FILE_DIRECTORY, FILE_NAME, SELECTED_SAMPLE_ID, mSelectedStudent, setFileUrLWithFileInfo]);

  const setColorOptions = useCallback((
    selected_position_color_option,
    colorOptions = mColorOption,
    shouldUpdateUrl = true
  ) => {
    const selectedColor = colorOptions[selected_position_color_option];
    setCOLOR_OPTION_ID(selectedColor ? selectedColor.color_option_id : "");

    if (mSelectedStudent.length > 0 && shouldUpdateUrl) {
      setFileUrL();
    }
  }, [mColorOption, mSelectedStudent.length, setFileUrL]);

  const getColorOptions = useCallback((
    selected_sample_position,
    samples = mInvitationSamples,
    shouldUpdateUrl = false
  ) => {
    const colorOptions = samples[selected_sample_position]?.color_options || [];
    setMColorOption(colorOptions);
    setColorOptions(SELECTED_COLOR_POSITION, colorOptions, shouldUpdateUrl);
  }, [mInvitationSamples, SELECTED_COLOR_POSITION, setColorOptions]);

  const setSample = useCallback((selected_sample_position, samples = mInvitationSamples) => {
    const sample = samples[selected_sample_position];
    if (!sample) return;

    const newFileName = sample.file_name;
    const newFileDirectory = sample.file_directory;
    const newSampleId = sample.sample_id;
    
    setFILE_NAME(newFileName);
    setFILE_DIRECTORY(newFileDirectory);
    setSELECTED_SAMPLE_ID(newSampleId);
    getColorOptions(selected_sample_position, samples, false);
    
    // Update URL with new file info
    setFileUrLWithFileInfo(newFileDirectory, newFileName, newSampleId);
  }, [mInvitationSamples, getColorOptions, setFileUrLWithFileInfo]);

  const changeColor = useCallback((index) => {
    setSELECTED_COLOR_POSITION(index);
    setShowInvitationPreview(true);
    setColorOptions(index, mColorOption);
  }, [mColorOption, setColorOptions]);

  const changeSample = useCallback((position) => {
    setSELECTED_SAMPLE_POSITION(position);
    setShowInvitationPreview(true);
    setSample(position);
  }, [setSample]);

  const SelectStudent = useCallback(() => {
    setIsOpenSelectStudent(true);
  }, []);

  const HandleCloseSelectStudent = useCallback(() => {
    setIsOpenSelectStudent(false);
  }, []);

  const HandleSelectedStudent = useCallback((selectedStudents) => {
    const students = selectedStudents || [];
    setIsOpenSelectStudent(false);
    setShowInvitationPreview(true);
    setMSelectedStudent(students);
    setFileUrL(students);
  }, [setFileUrL]);

  // Memoize event name
  const eventName = useMemo(() => {
    return eventDetails?.event_name || eventDetails?.name || eventDetails?.title || `Event #${EVENT_ID}`;
  }, [eventDetails, EVENT_ID]);

  // Memoize event type
  const eventType = useMemo(() => {
    if (eventDetails?.event_type) return eventDetails.event_type;
    const isPaid = eventDetails?.is_paid === 'Yes' || eventDetails?.is_paid === '1' || eventDetails?.is_paid === true;
    return isPaid ? 'Paid Event' : 'Free Event';
  }, [eventDetails]);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  return (
    <div className="content event-invitation">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#" style={{ color: COLORS.white }}>
                Event Invitation
              </a>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="page-card">
        {/* Modern Header Section */}
        <div className="header-section">
          <div className="header-content">
            <h5>Event Invitation</h5>
            <small>Create beautiful invitations for your school events</small>
          </div>
          <div className="header-icon">
            <i className="fa fa-envelope"></i>
          </div>
        </div>

        {/* Event Details and Student Selection in One Row */}
        <div style={{ display: "flex", gap: "16px", margin: "16px 20px 0 20px" }}>
          {/* Event Details - Col-md-6 */}
          <div style={{ flex: "1" }}>
            <div className="selection-section">
              <h5 className="section-title">
                <i className="fa fa-calendar" style={{ marginRight: "6px" }} />
                Event Details
              </h5>
              {eventDetails ? (
                <div className="event-details-card">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ margin: "0 0 6px 0" }}>{eventName}</h4>
                      <p style={{ margin: 0 }}>
                        <strong>Type:</strong> {eventType}
                      </p>
                    </div>
                    <button
                      className="selection-button"
                      onClick={handleOpenEventDialog}
                      style={{ marginTop: "0", flexShrink: 0 }}
                    >
                      <i className="fa fa-exchange" />
                      Change
                    </button>
                  </div>
                </div>
              ) : (
                <div className="event-details-card">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ margin: "0 0 6px 0", color: COLORS.grey2 }}>No Event Selected</h4>
                      <p style={{ margin: 0, color: COLORS.grey3 }}>Select an event to create invitations</p>
                    </div>
                    <button
                      className="selection-button"
                      onClick={handleOpenEventDialog}
                      style={{ marginTop: "0", flexShrink: 0 }}
                    >
                      <i className="fa fa-plus" />
                      Select Event
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Student Selection - Col-md-6 */}
          <div style={{ flex: "1" }}>
            <div className="selection-section select-recipients">
              <h5 className="section-title">
                <i className="fa fa-users" style={{ marginRight: "6px" }} />
                Select Recipients
              </h5>
              <div className="selection-buttons">
                <button
                  className="selection-button"
                  onClick={SelectStudent}
                >
                  <i className="fa fa-user-plus" />
                  Select Students Manually
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Templates Section */}
        <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
          <h5 className="section-title">
            <i className="fa fa-palette" style={{ marginRight: "6px" }} />
            Invitation Templates
          </h5>
          <div className="templates-grid">
            {mInvitationSamples.map((item, index) => (
              <div
                key={item.sample_id || index}
                className={`template-item ${SELECTED_SAMPLE_POSITION === index ? 'active' : ''}`}
                onClick={() => changeSample(index)}
              >
                <i className="fa fa-file-text-o template-icon"></i>
                <div className="template-name">{item.sample_name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Color Options Section - Only show if color options exist */}
        {mColorOption.length > 0 && (
          <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
            <h5 className="section-title">
              <i className="fa fa-paint-brush" style={{ marginRight: "6px" }} />
              Color Options
            </h5>
            <div className="color-options">
              {mColorOption.map((item, index) => {
                const [color1, color2] = item.sample_color_code?.split("_") || ["#000", "#000"];
                return (
                  <div
                    key={item.color_option_id || index}
                    className={`color-option ${SELECTED_COLOR_POSITION === index ? 'active' : ''}`}
                    onClick={() => changeColor(index)}
                  >
                    <div className="color-display">
                      <div style={{ backgroundColor: color1 }}></div>
                      <div style={{ backgroundColor: color2 }}></div>
                    </div>
                    <div className="color-name">{item.sample_color_name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Preview Section */}
        <div className="preview-section" style={{ margin: "16px 20px 20px 20px" }}>
          <h5 className="section-title">
            <i className="fa fa-eye" style={{ marginRight: "6px" }} />
            Preview
          </h5>
          <div className="preview-frame">
            {showInvitationPreview && <MyLoader />}
            {FILE_URL && (
              <Iframe
                key={FILE_URL}
                url={FILE_URL}
                width="100%"
                height={height}
                style={{ border: "none", overflow: "hidden" }}
                id="iFrameInvitation"
                display="initial"
                position="relative"
                onLoad={() => setShowInvitationPreview(false)}
              />
            )}
          </div>
        </div>
      </div>

      {isOpenSelectStudent && (
        <MdlSelectMultipleStudent
          actionClose={HandleCloseSelectStudent}
          actionHandleSelected={HandleSelectedStudent}
        />
      )}

      {/* Event Selection Modal */}
      {isOpenEventDialog && (
        <Modal show={isOpenEventDialog} onHide={handleCloseEventDialog} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa fa-calendar" style={{ marginRight: "8px" }} />
              Select Event
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingEvents ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize: "32px", marginBottom: "16px" }} />
                <p>Loading events...</p>
              </div>
            ) : eventList.length > 0 ? (
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {eventList.map((event) => (
                  <div
                    key={event.event_id}
                    onClick={() => handleSelectEvent(event)}
                    style={{
                      padding: "16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      marginBottom: "12px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      backgroundColor: "#fff"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = COLORS.primary_color_shade6;
                      e.currentTarget.style.backgroundColor = "#f8fafc";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#e5e7eb";
                      e.currentTarget.style.backgroundColor = "#fff";
                    }}
                  >
                    <h5 style={{ margin: "0 0 8px 0", color: COLORS.primary_color_shade8 }}>
                      {event.event_name}
                    </h5>
                    <p style={{ margin: "0", color: COLORS.grey2, fontSize: "14px" }}>
                      <strong>Type:</strong> {event.event_type} | 
                      <strong> Date:</strong> {event.start_date} to {event.end_date}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "40px", color: COLORS.grey3 }}>
                <i className="fa fa-calendar-times" style={{ fontSize: "32px", marginBottom: "16px" }} />
                <p>No events found</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn secondary" onClick={handleCloseEventDialog}>
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default EventInvitation;
